import React, {useState} from 'react'
import './MapLayersPanel.scss'
import Checkbox from "@material-ui/core/Checkbox";
import LayersIcon from '@material-ui/icons/Layers';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import IconButton from "@material-ui/core/IconButton";

export default function MapLayersPanel({layers, onLayerVisibleChange}) {
    const [isOpen, setOpen] = useState(false);
    const domRef = React.useRef();

    function handleCheck(key, event, value) {
        onLayerVisibleChange(key, value);
    }

    function handleMouseEnter() {
        if (!isTouchDevice())
            openPanel();
    }

    function handleTouchEnd() {
        if (isTouchDevice())
            openPanel();
    }

    function isTouchDevice() {
        return 'ontouchstart' in document.documentElement;
    }

    function openPanel() {
        if (!isOpen) {
            setOpen(true);

            let checkMouseLeave = (e) => {
                if (domRef.current && !domRef.current.contains(e.target)) {
                    setOpen(false);
                    window.removeEventListener('mousemove', checkMouseLeave);
                }
            }

            window.addEventListener('mousemove', checkMouseLeave);
        }
    }

    return (
        <div ref={domRef}>
            <div className={`layers-container ${isOpen ? "" : "layers-container-closed"}`}
                 onMouseEnter={handleMouseEnter}
                 onTouchEnd={handleTouchEnd}>
                {
                    !isOpen ?
                        <IconButton>
                            <LayersIcon/>
                        </IconButton>
                        :
                        <div className="layers-panel">
                            {Object.keys(layers).map(key => {
                                const currentLayer = layers[key];

                                return (
                                    <FormControlLabel
                                        className="layer-display-name"
                                        key={key}
                                        label={currentLayer.displayName}
                                        control={
                                            <Checkbox
                                                checked={currentLayer.visible}
                                                onChange={(event, value) => handleCheck(key, event, value)}
                                            />
                                        }
                                    />
                                );
                            })}
                        </div>
                }
            </div>
        </div>
    );
}